import React, { useEffect, useState } from "react";
import LVCuadricula from "../../Complejos/Generales/LVCuadricula";
import { function_ABM_ART_Articulos_Horarios, function_ABM_ART_Articulos_ReservablesDetalleEstablecimiento } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Articulos";
import { FormateoFechaPara_yyyyMMdd, FormateoFechaPara_yyyyMMdd_HHmmss } from "neftis7_apicaller/src/funciones/Varios";
import { function_ABM_ART_UnidadesMedida_Leer } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_UnidadesMedida";

export const VEN_Reservas_DisponibilidadPorArticulo = (props) => {
  const [loading, setLoading] = useState(false)
  const [dataHorarios, setDataHorarios] = useState([])

  const [dataActividades, setDataActividades] = useState([])
  const [codigoArticulo, setCodigoArticulo] = useState(props.CodigoArticulo)
  const [articulo, setArticulo] = useState("")
  const [precio, setPrecio] = useState(0)
  const [codigoPresentacion, setCodigoPresentacion] = useState("")
  const [codigoTamano, setCodigoTamano] = useState("")
  const [codigoUnidadMedida, setCodigoUnidadMedida] = useState("")
  const [actividad, setActividad] = useState("")
  const [hora, setHora] = useState("")
  const [cantidad, setCantidad] = useState(props.Cantidad)

  const handleActividadClick = async (IdBoton) => {
    const actividad = dataActividades.find(item => item.IdBoton === IdBoton);

    setCodigoPresentacion(actividad.CodigoPresentacion)
    setCodigoTamano(actividad.CodigoTamano)
    setCodigoUnidadMedida(actividad.CodigoUnidadMedida)
    setActividad(actividad.DescripcionEstablecimiento)
    setPrecio(actividad.Precio)

    const resultHorarios = await function_ABM_ART_Articulos_Horarios(props.CodigoArticulo, await FormateoFechaPara_yyyyMMdd(props.Fecha))

    const resultHorariosHabilitados = resultHorarios.data.map(item => ({
      ...item,  // Copia todos los campos existentes
      Habilitado: true,  // Agrega el campo Habilitado con valor true
      Descripcion: item.HoraMinuto + "     Disp.: " + item.LugaresDisponibles,
      Color: -14330269
    }));

    setDataHorarios(resultHorariosHabilitados)
  };

  const handleHorarioClick = async (Horario) => {
    setHora(Horario)


    const fechaNueva = new Date(props.Fecha);
    const [hours, minutes] = Horario.split(':');
    const seconds = "00"
    const fechaYHora = new Date(fechaNueva.setHours(hours, minutes, seconds));
    const UM = await function_ABM_ART_UnidadesMedida_Leer(codigoUnidadMedida)

    const fechaYHoraFin = new Date(fechaYHora);
    fechaYHoraFin.setMinutes(fechaYHoraFin.getMinutes() + UM.data[0].Cantidad);

    const nuevoDetalle = {
      Identificador: props.Identificador,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
      CodigoPlanta: localStorage.getItem("CodigoPlanta"),
      CodigoArticulo: codigoArticulo,
      CodigoPresentacion: codigoPresentacion,
      CodigoTamano: codigoTamano,
      CodigoUnidadMedida: codigoUnidadMedida,
      Fecha: props.Fecha,
      Horario: Horario,
      FechaReservaInicio: await FormateoFechaPara_yyyyMMdd_HHmmss(fechaYHora),
      FechaReservaFin: await FormateoFechaPara_yyyyMMdd_HHmmss(fechaYHoraFin),
      Importe: precio,
      Cantidad: cantidad,
    };

    // Filtrar los detalles que no tengan el Identificador actual
    props.SetDataDetalles((dataDetalles) =>
      [...dataDetalles.filter(detalle => detalle.Identificador !== props.Identificador), nuevoDetalle]
    );
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const resultActividades = await function_ABM_ART_Articulos_ReservablesDetalleEstablecimiento(props.CodigoArticulo, "LP")
        const resultActividadesHabilitados = resultActividades.data.filter(item => item.Habilitado);

        if (resultActividadesHabilitados && resultActividadesHabilitados.length > 0) {
          setDataActividades(resultActividadesHabilitados)
          setCodigoArticulo(props.CodigoArticulo)

          setArticulo(resultActividadesHabilitados[0].Articulo)
        }
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div className="LV-GroupBox-div"
          style={{ marginBottom: '10px', marginTop: '10px', position: "relative" }}
        >
          <div
            style={{ marginBottom: '10px', marginTop: '10px' }}
          >
            <label>
              {actividad !== "" ? hora !== "" ? `${cantidad} x ${articulo} - ${actividad} ($${precio * cantidad}) - ${hora}` : `${cantidad} x ${articulo} - ${actividad} ($${precio * cantidad})` : `${cantidad} x ${articulo}`}
            </label>
          </div>
          <div className="LV-FlexContainer"
            style={{ marginBottom: '10px', marginTop: '10px', gap: '20px' }}
          >
            <LVCuadricula
              data={dataActividades}
              IdGrupo={0}
              CantidadDeBotonesHorizontal={8}
              AltoBotones={70}
              AnchoBotones={70}
              CampoCodigo={"IdBoton"}
              CampoDescripcion={"DescripcionEstablecimiento"}
              onButtonClick={handleActividadClick} />

            <LVCuadricula
              data={dataHorarios}
              IdGrupo={0}
              CantidadDeBotonesHorizontal={8}
              AltoBotones={70}
              AnchoBotones={70}
              CampoCodigo={"HoraMinuto"}
              CampoDescripcion={"Descripcion"}
              onButtonClick={handleHorarioClick} />

            {/* Botón para eliminar */}
            <button
              onClick={props.onEliminar}
              style={{
                position: "absolute",
                top: "5px",
                right: "5px",
                background: "transparent",
                border: "none",
                color: "#900",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "18px",
                fontWeight: "bold",
                cursor: "pointer"
              }}
            >
              X
            </button>
          </div>
        </div>
      )
      }
    </div >
  );
};
